import PresentationScreen from "../presentation-screen/PresentationScreen";
import ProjectComponent from "../../components/project-component/ProjectComponent";
import ProjectNav, { ListItem } from '../../components/project-nav/ProjectNav';
import { Element } from "react-scroll";
import { Helmet } from "react-helmet";
import LoadingScreen from "../../components/loading-screen/LoadingScreen";
import AndroidVideo from "../../assets/mp4/google-android.mp4"
import {
    AndroidLogo,
    MbLogo,
    MeliLogo,
    NuBankLogo,
    VenturisyLogo
} from "../../assets/svg";

import {
    MeliProject,
    NuBankProject,
    PanProject,
    PanLogo,
    MbProject,
    PngVenturisyThumb
} from "../../assets/png";
import "./Home.scss";

const Home = () => {

    const projectList: ListItem[] = [
        { id: 'section-home', title: '', dontShow: true },
        { id: 'section-0', title: 'nubank' },
        { id: 'section-1', title: 'mercado livre' },
        { id: 'section-2', title: 'android.com', blackText: true },
        { id: 'section-3', title: 'ugly cash' },
        { id: 'section-', title: 'banco pan', blackText: true },
        // { id: 'section-5', title: 'venturisy' },
    ]

    return (
        <div>
            <Helmet>
                <title>Gabriel Castro</title>
            </Helmet>
            <ProjectNav
                listItems={projectList}
            />
            <LoadingScreen />
            <Element name='section-home'>
                <section id="section-home">
                    <PresentationScreen />
                </section>
            </Element>
            <Element name='section-0'>
                <section id='section-0'>
                    <ProjectComponent
                        projectTitle='Consumption <br> Coach'
                        projectDescription="NuBank's personal financial manager."
                        projectImg={NuBankProject}
                        logo={NuBankLogo}
                        backgroundColor="#5B0694"
                        secondaryColor="var(--color-secondary)"
                        link='/nubank'
                    />
                </section>
            </Element>
            <Element name='section-1'>
                <section id='section-1'>
                    <ProjectComponent
                        projectTitle="Seller's admin <br> ecommerce"
                        projectDescription="Redesign of the Mercado Pago's sellers onboarding."
                        projectImg={MeliProject}
                        logo={MeliLogo}
                        backgroundColor='#03A9E3'
                        secondaryColor='var(--color-secondary)'
                        link='/meli'
                    />
                </section>
            </Element>
            <Element name='section-2'>
                <section id='section-2'>
                    <ProjectComponent
                        projectTitle='Why Android <br> promational page'
                        projectDescription="Internal page for Android.com (WIP)"
                        thumbVideo={AndroidVideo}
                        logo={AndroidLogo}
                        backgroundColor='#EFF2F9'
                        secondaryColor='#262628'
                        link='https://www.android.com/intl/en_us/why-android/'
                    />
                </section>
            </Element>
            <Element name='section-3'>
                <section id='section-3'>
                    <ProjectComponent
                        projectTitle='Design System <br> and app concept'
                        projectDescription="Launching of the MVP of the wallet"
                        projectImg={MbProject}
                        logo={MbLogo}
                        backgroundColor='#141414'
                        secondaryColor='var(--color-secondary)'
                        link='/uglycash'
                    />
                </section>
            </Element>
            <Element name='section-4'>
                <section id='section-4'>
                    <ProjectComponent
                        projectTitle='New Digital <br> Bank'
                        projectDescription="Launching of the MVP of a Bank."
                        projectImg={PanProject}
                        logo={PanLogo}
                        backgroundColor='var(--color-secondary)'
                        secondaryColor='var(--color-primary)'
                        link='/bancopan'
                    />
                </section>
            </Element>

            {/* <Element name='section-5'>
                <section id='section-5'>
                    <ProjectComponent
                        projectTitle='Ushuaia experiences booking web'
                        projectDescription="Website // WIP"
                        projectImg={PngVenturisyThumb}
                        logo={VenturisyLogo}
                        backgroundColor='#201F2F'
                        secondaryColor='var(--color-secondary)'
                        link=''
                    />
                </section>
            </Element> */}

        </div>
    )
}

export default Home